import React, { useState, useEffect } from 'react';
import {
  MessageCircle,
  Users,
  Star,
  Building2,
  Shield,
  CheckCircle,
  Calculator,
  FileText,
  Phone,
  Mail
} from 'lucide-react';
import baseURL from '../url';
import Navbar from '../Navbar/Navbar';

const Financiacion = () => {
  const [bannerImages, setBannerImages] = useState([]);
  const [bancosImage, setBancosImage] = useState({ desktop: '', mobile: '' });
  const [loading, setLoading] = useState(true);

  const handleWhatsAppClick = () => {
    const phoneNumber = "5491134567890";
    const message = "Hola! Me interesa solicitar asesoramiento sobre financiación para comprar un auto.";
    window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`, '_blank');
  };

  const handleAsesoramientoClick = () => {
    console.log("Redirigir a formulario de asesoramiento");
  };

  const cargarBanners = () => {
    fetch(`${baseURL}/bannersGet.php`, {
      method: 'GET',
    })
      .then(response => response.json())
      .then(data => {
        console.log('API Response:', data); // Debug log

        if (data.banner && Array.isArray(data.banner)) {
          const filteredImages = data.banner
            .filter(banner => banner.financiacion === 1)
            .map(banner => banner.imagen);

          console.log('Filtered images:', filteredImages); // Debug log
          setBannerImages(filteredImages);
        }
        setLoading(false);
      })
      .catch(error => {
        console.error('Error al cargar banners:', error);
        setLoading(false);
      });
  };

  useEffect(() => {
    cargarBanners();
  }, []);

  return (
    <div className="financiacion-page">
      {/* Hero Section Simplificado */}
      <Navbar />

      <section className="hero-section">
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <br />
              <br />
              <h1>FINANCIAMOS TU MOTO</h1>
              <p className="subtitle">
                ¡Contamos con los mejores creditos bancarios!
                <br />
                Accede a tu moto sin complicaciones, solo con tu DNI y disfruta de una financiacion rápida y segura.
              </p>

              <div className="cta-buttons">
                <button className="btn-primary" onClick={handleAsesoramientoClick}>
                  <Users className="btn-icon" />
                  Solicitar asesoramiento
                </button>
                <button className="boton" onClick={handleWhatsAppClick}>
                  <MessageCircle className="btn-icon" />
                  WhatsApp
                </button>
              </div>


            </div>

            <div className="hero-image" style={{ marginTop: '50px' }}>
              {!loading && bannerImages.length > 0 ? (
                // Mostrar imágenes dinámicas del banner
                <div className="banner-slider">
                  {bannerImages.map((imageUrl, index) => (
                    <img
                      key={index}
                      src={imageUrl}
                      alt={`Financiación ${index + 1}`}
                      className="hero-img banner-image"
                      onError={(e) => {
                        console.error(`Error loading banner image ${index + 1}:`, imageUrl);
                        e.target.style.display = 'none';
                      }}
                      onLoad={() => {
                        console.log(`Banner image ${index + 1} loaded successfully:`, imageUrl);
                      }}
                    />
                  ))}
                </div>
              ) : (
                // Imagen de respaldo mientras carga o si no hay imágenes
                <img
                  src="https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80"
                  alt="Financiación de autos"
                  className="hero-img"
                  onError={(e) => {
                    console.error('Error loading fallback hero image');
                    e.target.src = 'https://via.placeholder.com/600x400/cccccc/666666?text=Imagen+no+disponible';
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Imagen de Bancos */}
      {/*  <section className="bancos-image-section">
        <div className="container">
          {(bancosImage.desktop || bancosImage.mobile) && (
            <div className="bancos-image-container"> */}
      {/* Imagen para Desktop */}
      {/* {bancosImage.desktop && (
                <img 
                  src={bancosImage.desktop} 
                  alt="Bancos adheridos" 
                  className="bancos-image desktop"
                  onError={(e) => {
                    console.error('Error loading desktop bancos image');
                    e.target.style.display = 'none';
                  }}
                />
              )} */}

      {/* Imagen para Mobile */}
      {/* {bancosImage.mobile && (
                <img 
                  src={bancosImage.mobile} 
                  alt="Bancos adheridos" 
                  className="bancos-image mobile"
                  onError={(e) => {
                    console.error('Error loading mobile bancos image');
                    e.target.style.display = 'none';
                  }}
                />
              )} */}
      {/*     </div>
          )}
        </div>
      </section> */}

      {/* Proceso Rápido */}
      {/*  <section className="process-section">
        <div className="container">
          <h2 className="section-title">Proceso simple</h2>
          
          <div className="process-steps">
            <div className="step">
              <div className="step-number">1</div>
              <MessageCircle className="step-icon" />
              <h3>Consultá</h3>
              <p>WhatsApp o formulario</p>
            </div>

            <div className="step">
              <div className="step-number">2</div>
              <Calculator className="step-icon" />
              <h3>Evaluamos</h3>
              <p>Tu perfil crediticio</p>
            </div>

            <div className="step">
              <div className="step-number">3</div>
              <FileText className="step-icon" />
              <h3>Gestionamos</h3>
              <p>Toda la documentación</p>
            </div>

            <div className="step">
              <div className="step-number">4</div>
              <CheckCircle className="step-icon" />
              <h3>¡Listo!</h3>
              <p>Retirás tu auto</p>
            </div>
          </div>
        </div>
      </section> */}

      {/* CTA Final */}
      {/* <section className="final-cta">
        <div className="container">
          <div className="cta-content">
            <h2>¿Te ayudamos a financiar tu auto?</h2>
            <div className="final-buttons">
              <button className="btn-primary large" onClick={handleAsesoramientoClick}>
                <Users className="btn-icon" />
                Asesoramiento gratuito
              </button>
              <button className="btn-secondary large" onClick={handleWhatsAppClick}>
                <MessageCircle className="btn-icon" />
                WhatsApp
              </button>
            </div>
            
            <div className="contact-info">
              <div className="contact-item">
                <Phone className="contact-icon" />
                <span>(011) 1234-5678</span>
              </div>
              <div className="contact-item">
                <Mail className="contact-icon" />
                <span>financiacion@tuauto.com</span>
              </div>
            </div>
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default Financiacion;